import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyAvailableGridItem = {
    width: 12,
    css: css`
        display: none;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 0 10px;
                        white-space: nowrap;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.resetButton = {
    variant: "tertiary",
    css: css`
        margin-right: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 0 10px;
                        white-space: nowrap;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.customerPriceHeadingAndText = {
    heading: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 13px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.minimumPriceAllowedHeadingAndText = {
    heading: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 13px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.unitCostHeadingAndText = {
    heading: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 13px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.listPriceHeadingAndText = {
    heading: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 13px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};
rfqQuoteDetailsQuoteLineCalculatorStyles.customerPriceGridItem = {
    width: 3,
    css: css`
        [data-test-selector="heading"] {
            white-space: nowrap;
        }
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.minimumPriceAllowedGridItem = {
    width: 3,
    css: css`
        [data-test-selector="heading"] {
            white-space: nowrap;
        }
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.applyButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 0 10px;
                        white-space: nowrap;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.qtyAvailableHeadingAndText = {
    heading: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 13px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};
